/**
 * 图表 tooltip 统一配置
 * 字体 12、字重 300、左侧图例色块、不裁切、完整显示
 */

/** 数值轴不显示小数，所有坐标轴统一使用 */
export const AXIS_LABEL_INTEGER = {
  formatter: (value: number) =>
    Number.isFinite(value) ? Math.round(value).toString() : "0",
};

/** 统一 tooltip 样式：字号 12、字重 300、不限制在容器内、无边框 */
export const UNIFIED_TOOLTIP_STYLE = {
  textStyle: {
    fontSize: 12,
    fontWeight: 300 as const,
  },
  confine: false as const,
  borderWidth: 0 as const,
};

/**
 * 生成带左侧图例色块的一行（用于 tooltip formatter）
 * @param color 系列颜色，缺省为 #999
 * @param text 该行文本（可含 HTML 如 <br/>）
 */
export function tooltipLine(color: string | undefined, text: string): string {
  const c = color ?? "#999";
  return `<span style="display:inline-block;width:10px;height:10px;background:${c};margin-right:6px;vertical-align:middle;border-radius:1px;"></span>${text}<br/>`;
}
